import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { Button } from '@components/Button';
import { CloudImage } from '@components/CloudImage';
import { CTALink } from '@components/CTALink';
import { themeMediaQuery, themeColor, themeSpace, themeVariant } from '@utils/styledTheme.util';
import { animationTransition } from '@utils/animationTransition';

export const TitleText = styled(Text)`
  margin: 0 auto ${themeSpace(8)};
`;

export const ExploreButton = styled(Button)`
  display: block;
  width: 235px;
  margin: 0 auto ${themeSpace(9)};

  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: auto;
  gap: ${themeSpace(5)};
  max-width: 100%;

  ${themeMediaQuery('sm')} {
    grid-template-columns: repeat(3, 1fr);
    max-width: 67.5rem;
  }
  ${themeMediaQuery('lg')} {
    gap: ${themeSpace(8)};
    max-width: 79.5rem;
  }
`;

export const StyledClickableBox = styled('a')`
  background: #f9f5f0;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  aspect-ratio: 1;
  &:hover {
    img {
      transform: scale(1.2) translate(-50%, 0);
    }
  }
  ${themeMediaQuery('below_sm')} {
    border-radius: 0px;
  }
`;

export const StyledContentBox = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: ${themeSpace(3)};
  position: relative;
`;

export const StyledContentHeader = styled(Text)`
  ${themeMediaQuery('sm')} {
    ${themeVariant('calloutHed32')};
  }
`;

export const StyledCTALink = styled(Text)`
  align-self: center;
  border-radius: 16px;
  color: ${themeColor('neutra6')};
  padding: ${themeSpace(3)} ${themeSpace(4)} ${themeSpace(3)};
  border: 1px solid ${themeColor('neutra6')};
  font-size: 15px;
  line-height: 120%;
  font-weight: 600;
  &:hover {
    border-color: ${themeColor('actionPurple3')};
    color: ${themeColor('actionPurple3')};
  }
  ${themeMediaQuery('below_sm')} {
    font-size: 9px;
    padding: ${themeSpace(2)} ${themeSpace(4)} ${themeSpace(2)};
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 100%;
  height: 100%;
  transition: ${animationTransition('transform')};
  transform: translate(-50%, 0);
`;

export const FindRoleBox = styled(Box)`
  text-align: center;
`;

export const GetinTouchCTALink = styled(CTALink)`
  text-align: center;
  border-radius: 4px;
  margin-top: ${themeSpace(2)};
  color: ${themeColor('neutra6')};
  padding: ${themeSpace(2)} ${themeSpace(5)};
  border: 1px solid ${themeColor('neutra6')};
  &:hover {
    border-color: ${themeColor('actionPurple3')};
  }
`;
